import { gsap } from "gsap";

const headerEl = document.querySelector(".header");
const headerInitialTop = headerEl ? headerEl.style.top : "";
const isInfoMob = window.matchMedia("(max-width: 769px)");
const setMobileInfoHeader = (isOpen) => {
  if (!headerEl) return;

  if (!isInfoMob.matches || !isOpen) {
    headerEl.style.top = headerInitialTop;
    return;
  }

  const headerHeight = headerEl.offsetHeight || headerEl.scrollHeight;
  headerEl.style.top = `-${headerHeight + 3}px`;
};
const isTab = window.matchMedia("(max-width: 1025px)");
const isMob = window.matchMedia("(max-width: 551px)");
const isMob768 = window.matchMedia("(max-width: 768px)");
const isDesk1281 = window.matchMedia("(max-width: 1281px)");

// Конфигурация смещения для разных регионов
const REGION_OFFSET = {
  USA: window.innerWidth > 640 ? 200 : 100,
  UK: window.innerWidth > 640 ? 100 : 0,
  EU: 100
};

const mapSection = document.querySelector(".map");

if (mapSection) {
  // ========== CHART FLAG ==========
  // Поставь true, чтобы включить графики Chart.js
  const ENABLE_CHARTS = false;
  // ================================

  // MAP CHART
  const setChart = !ENABLE_CHARTS ? () => { } : (countryChartEl) => {
    if (countryChartEl.dataset.chartInitialized) return;
    countryChartEl.dataset.chartInitialized = 'true';

    const chartWrap = countryChartEl.querySelector(".map__chart");
    const chartCanvasWrap = countryChartEl.querySelector(
      ".map__chart-canvas-wrap"
    );
    const chartChartTable = countryChartEl.querySelector(".map__chart-table");
    const chartTableHandsOn = countryChartEl.querySelector(
      ".map__chart-table-item-list[data-type='hands-on']"
    );
    const chartTableAreas = countryChartEl.querySelector(
      ".map__chart-table-item-list[data-type='areas']"
    );
    const chartTableManagement = countryChartEl.querySelector(
      ".map__chart-table-item-list[data-type='management']"
    );

    const chartTableHandsOnItems = chartTableHandsOn.querySelectorAll(
      ".map__chart-table-item"
    );
    const chartTableAreasItems = chartTableAreas ? chartTableAreas.querySelectorAll(".map__chart-table-item") : [];
    const chartTableManagementItems = chartTableManagement ? chartTableManagement.querySelectorAll(".map__chart-table-item") : [];

    // set only number for data-percentage
    [
      ...chartTableHandsOnItems,
      ...chartTableAreasItems,
      ...chartTableManagementItems,
    ].forEach((item) => {
      item.setAttribute(
        "data-percentage",
        parseFloat(item.getAttribute("data-percentage").replace(/^\D+/g, "")).toString()
      );
    });

    const percDOM = countryChartEl.querySelector(".map__chart-perc");
    const percTextDOM = countryChartEl.querySelector(".map__chart-perc-text");

    countryChartEl.addEventListener("click", (e) => {
      if (
        isMob768.matches &&
        e.target === e.currentTarget
      ) {
        activeChart?.classList.remove("is-open");
        scrollLock.enablePageScroll();
        setMobileInfoHeader(false);
      }
    });

    const BACKGROUND_COLORS = [
      "rgba(6, 23, 46, 1)",
      "rgba(239, 27, 46, 1)",
      "rgba(115, 27, 239, 1)",
      "rgba(27, 239, 186, 1)",
      "rgba(226, 118, 0, 1)",
      "rgba(182, 67, 194, 1)",
      "rgba(226, 171, 28, 1)",
    ];
    const BACKGROUND_HOVER_COLORS = [
      "rgba(6, 23, 46, 0.7)",
      "rgba(239, 27, 46, 0.7)",
      "rgba(115, 27, 239, 0.7)",
      "rgba(27, 239, 186, 0.7)",
      "rgba(226, 118, 0, 0.7)",
      "rgba(182, 67, 194, 0.7)",
      "rgba(226, 171, 28, 0.7)",
    ];
    const BACKGROUND_ACTIVE_COLORS = [
      "rgba(6, 23, 46, 0.5)",
      "rgba(239, 27, 46, 0.5)",
      "rgba(115, 27, 239, 0.5)",
      "rgba(27, 239, 186, 0.5)",
      "rgba(226, 118, 0, 0.5)",
      "rgba(182, 67, 194, 0.5)",
      "rgba(226, 171, 28, 0.5)",
    ];

    const handleTabChange = (type) => {
      activeTable.classList.remove("active");
      activeTable = getTable(type);
      activeTable.classList.add("active");

      chart.data = getData(type);

      if (chart.data.labels.length) {
        chart.update();
        chartCanvasWrap.style.display = "flex";
        chartChartTable.style.display = "block";
      } else {
        chartCanvasWrap.style.display = "none";
        chartChartTable.style.display = "none";
      }

      if (type === "areas") {
        chartCanvasWrap.classList.add("not-chart-type");
        chartChartTable.classList.add("not-chart-type");
      } else {
        chartCanvasWrap.classList.remove("not-chart-type");
        chartChartTable.classList.remove("not-chart-type");
      }

      chart.update();

      [...countryChartEl.querySelectorAll("[data-simplebar]")].forEach((el) => {
        const simpleBar = SimpleBar.instances.get(el);
        simpleBar?.recalculate();
      });
    };

    const getData = (type) => {
      switch (type) {
        case "hands-on":
          return dataHandsOn;
        case "areas":
          return dataAreas;
        case "management":
          return dataManagement;
        default:
          break;
      }
    };

    const getTable = (type) => {
      switch (type) {
        case "hands-on":
          return chartTableHandsOn;
        case "areas":
          return chartTableAreas;
        case "management":
          return chartTableManagement;
        default:
          break;
      }
    };

    const tabBtns = countryChartEl.querySelectorAll(".map__chart-tab");

    let activeTab = tabBtns[0];
    let activeTable = getTable(tabBtns[0].dataset.type);

    const dataHandsOn = [...chartTableHandsOnItems].reduce(
      (acc, item) => {
        const { title, percentage } = item.dataset;
        acc.labels.push(title);
        acc.datasets[0].data.push(percentage);
        return acc;
      },
      {
        labels: [],
        datasets: [
          {
            activeData: null,
            data: [],
            backgroundColor: [...BACKGROUND_COLORS],
            hoverBackgroundColor: [...BACKGROUND_HOVER_COLORS],
            borderColor: "rgb(255, 255, 255)",
            hoverBorderColor: "rgb(255, 255, 255)",
            borderWidth: 2,
          },
        ],
      }
    );

    const dataAreas = [...chartTableAreasItems].reduce(
      (acc, item) => {
        const { title, percentage } = item.dataset;
        acc.labels.push(title);
        acc.datasets[0].data.push(percentage);
        return acc;
      },
      {
        labels: [],
        datasets: [
          {
            activeData: null,
            data: [],
            backgroundColor: [...BACKGROUND_COLORS],
            hoverBackgroundColor: [...BACKGROUND_HOVER_COLORS],
            borderColor: "rgb(255, 255, 255)",
            hoverBorderColor: "rgb(255, 255, 255)",
            borderWidth: 2,
          },
        ],
      }
    );

    const dataManagement = [...chartTableManagementItems].reduce(
      (acc, item) => {
        const { title, percentage } = item.dataset;
        acc.labels.push(title);
        acc.datasets[0].data.push(percentage);
        return acc;
      },
      {
        labels: [],
        datasets: [
          {
            activeData: null,
            data: [],
            backgroundColor: [...BACKGROUND_COLORS],
            hoverBackgroundColor: [...BACKGROUND_HOVER_COLORS],
            borderColor: "rgb(255, 255, 255)",
            hoverBorderColor: "rgb(255, 255, 255)",
            borderWidth: 2,
          },
        ],
      }
    );



    const activeDataRender = {
      id: "activeDataRender",
      beforeInit(chart) {
        if (!chart.config.data.datasets[0].activeData) {
          chart.config.data.datasets[0].backgroundColor[0] =
            BACKGROUND_ACTIVE_COLORS[0];
          chart.config.data.datasets[0].hoverBackgroundColor[0] =
            BACKGROUND_ACTIVE_COLORS[0];
        }
      },
      beforeUpdate(chart) {
        if (!chart.config.data.datasets[0].activeData) {
          chart.config.data.datasets[0].backgroundColor[0] =
            BACKGROUND_ACTIVE_COLORS[0];
          chart.config.data.datasets[0].hoverBackgroundColor[0] =
            BACKGROUND_ACTIVE_COLORS[0];
        }
      },

      afterDraw(chart, args, options) {
        const ctx = chart.canvas.getContext("2d");
        ctx.save();

        if (!chart.config.data.datasets[0].activeData) {
          const procentage = chart.config.data.datasets[0].data[0];
          const specialisms = chart.config.data.labels[0];

          chart.config.data.datasets[0].activeData = {
            procentage,
            specialisms,
            idx: 0,
          };
        }

        const { procentage, specialisms, idx } =
          chart.config.data.datasets[0].activeData;

        if (!isDesk1281.matches) {
          const findElementWithPool = (specialisms, percentage) => {
            const selector = `[data-title="${specialisms}"][data-percentage="${percentage}"]`;
            const element = document.querySelector(selector);

            if (element) {
              const dataPool = element.getAttribute("data-pool");
              return dataPool ? dataPool : "";
            } else {
              return "";
            }
          };

          const dataPoolValue = findElementWithPool(specialisms, procentage);

          ctx.font = "500 40px Montserrat";
          ctx.fillStyle = "rgb(6, 23, 46)";
          ctx.textAlign = "center";
          chart.ctx.textBaseline = "middle";
          let metrics = ctx.measureText(procentage);
          let actualHeight =
            metrics.actualBoundingBoxAscent + metrics.actualBoundingBoxDescent;
          const width = chart.width;
          const height = chart.height;

          ctx.fillText(
            dataPoolValue,
            width / 2,
            height / 2 - actualHeight / 2,
            136
          );

          ctx.font = "500 13px Montserrat";
          ctx.fillStyle = "rgb(51, 66, 79)";
          ctx.textAlign = "center";
          chart.ctx.textBaseline = "middle";
          const wrapText = function (ctx, text, x, y, maxWidth, lineHeight) {
            let words = text.split(" ");
            let line = "";
            let testLine = "";
            let lineArray = [];

            for (var n = 0; n < words.length; n++) {
              testLine += `${words[n]} `;
              let metrics = ctx.measureText(testLine);
              let testWidth = metrics.width;

              if (testWidth > maxWidth && n > 0) {
                lineArray.push([line, x, y]);
                y += lineHeight;
                line = `${words[n]} `;
                testLine = `${words[n]} `;
              } else {
                line += `${words[n]} `;
              }

              if (n === words.length - 1) {
                lineArray.push([line, x, y]);
              }
            }
            return lineArray;
          };
          const text = wrapText(
            ctx,
            specialisms.replace(/\s{2,}/g, " "),
            width / 2,
            height / 2 + actualHeight * 2,
            100,
            14
          );

          metrics = ctx.measureText(...text);
          actualHeight =
            metrics.actualBoundingBoxAscent + metrics.actualBoundingBoxDescent;

          text.forEach((item) => {
            ctx.fillText(item[0], item[1], item[2] - 12 * text.length);
          });
        } else {
          const { procentage, specialisms } =
            chart.config.data.datasets[0].activeData;

          percDOM.style.display = 'none';
          percTextDOM.textContent = specialisms;
        }
      },
    };

    const config = {
      type: "doughnut",
      data: getData(activeTab.dataset.type),
      plugins: [activeDataRender],
      options: {
        spacing: 7,
        cutoutPercentage: 75,
        responsive: true,
        borderColor: "#ffffff",
        onHover({ target: canvas }, elements) {
          canvas.style.cursor = elements.length ? "pointer" : "default";
        },
        onClick({ target }, elements) {
          const ctx = target.getContext("2d");
          ctx.save();

          if (elements.length) {
            const procentage =
              chart.config.data.datasets[0].data[elements[0]._index];
            const specialisms = chart.config.data.labels[elements[0]._index];

            chart.config.data.datasets[0].backgroundColor =
              chart.config.data.datasets[0].backgroundColor.map(
                (color, idx) => {
                  return BACKGROUND_COLORS[idx];
                }
              );

            chart.config.data.datasets[0].hoverBackgroundColor =
              chart.config.data.datasets[0].hoverBackgroundColor.map(
                (color, idx) => {
                  return BACKGROUND_HOVER_COLORS[idx];
                }
              );

            chart.config.data.datasets[0].backgroundColor[elements[0]._index] =
              BACKGROUND_ACTIVE_COLORS[elements[0]._index];
            chart.config.data.datasets[0].hoverBackgroundColor[
              elements[0]._index
            ] = BACKGROUND_ACTIVE_COLORS[elements[0]._index];

            chart.config.data.datasets[0].activeData = {
              procentage,
              specialisms,
              idx: elements[0]._index,
            };

            if (!isDesk1281.matches) {
              const findElementWithPool = (specialisms, percentage) => {
                const selector = `[data-title="${specialisms}"][data-percentage="${percentage}"]`;
                const element = document.querySelector(selector);

                if (element) {
                  const dataPool = element.getAttribute("data-pool");
                  return dataPool ? dataPool : "";
                } else {
                  return "";
                }
              };

              const dataPoolValue = findElementWithPool(specialisms, procentage);
              ctx.font = "500 36px Montserrat";
              ctx.fillStyle = "rgb(6, 23, 46)";
              ctx.textAlign = "center";
              chart.ctx.textBaseline = "middle";
              let metrics = ctx.measureText(
                chart.config.data.datasets[0].activeData.procentage
              );
              let actualHeight =
                metrics.actualBoundingBoxAscent +
                metrics.actualBoundingBoxDescent;
              const width = chart.width;
              const height = chart.height;

              ctx.fillText(
                dataPoolValue,
                width / 2,
                height / 2 - actualHeight / 2,
                136
              );
            } else {
              percDOM.style.display = 'none';
              percTextDOM.textContent = specialisms;
            }
            chart.update();
          }
        },
        legend: {
          display: false,
        },
        tooltips: {
          enabled: false,
        },
        plugins: {},
      },
    };

    if (typeof Chart === 'undefined') return;
    const chart = new Chart(countryChartEl.querySelector(".chart"), config);

    handleTabChange(activeTab.dataset.type);

    tabBtns.forEach((btn) => {
      btn.addEventListener("click", () => {
        if (activeTab === btn) return;

        handleTabChange(btn.dataset.type);
        activeTab.classList.remove("active");
        activeTab = btn;
        activeTab.classList.add("active");
      });
    });
  };

  const countryCharts = document.querySelectorAll(".map__chart-wrap");
  countryCharts.forEach(setChart);

  let activeChart = null;

  const getChart = (country) => {
    return [...countryCharts].find((item) => item.dataset.country === country);
  };

  // Offices info
  const officesTitle = document.querySelector(".map__offices-title");
  const officesText = document.querySelector(".map__offices-offices-text");

  // MAP
  let isFirstZoom = true;
  let currentAnimationTarget = null;
  let activeAnimations = [];
  let setMapRetryCount = 0;
  const SET_MAP_MAX_RETRIES = 3;

  const setMap = () => {
    try {
      const map = mapSection.querySelector(".map__wrap svg");

      const moveUkBtn = document.querySelector("#to-uk");
      const moveUsaBtn = document.querySelector("#to-usa");
      const moveEuBtn = document.querySelector("#to-eu");
      const openPercBtn = document.querySelector(".map__open-perc-btn");
      const closePercBtns = document.querySelectorAll(".map__chart-close-btn");
      const chartWrapCloseBtns = document.querySelectorAll(".map__chart-wrap-close");

      // const euCountries = [
      //   "#BE", "#PT", "#PL", "#NL", "#BG", "#IT", "#DE", "#FR", "#ES", "#HR",
      //   "#RO", "#SI", "#SK", "#CZ", "#AT", "#CH", "#BA", "#HU", "#RS", "#ME",
      //   "#XK", "#AL", "#MK", "#TR", "#GR", "#UK", "#MD", "#DK", "#SE", "#NO",
      //   "#FI", "#LT", "#LV", "#EE", "#BY",
      // ];

      const euCountries = [
        "#SG", "#HK", '#CN'
      ];

      const baseViewBox = map.getAttribute("viewBox");
      const defaultCountries = [
        {
          btn: moveUkBtn,
          list: ["#GB", "#IR"],
        },
        {
          btn: moveUsaBtn,
          list: ["#CA", "#US"],
        },
        {
          btn: moveEuBtn,
          list: ["#SG", "#HK", '#CN'],
        },
      ];

      const svgGrayStop1 = map.querySelector("#grayStopColor1");
      const svgGrayStop2 = map.querySelector("#grayStopColor2");
      const svgGradientStop1 = map.querySelector("#grStopColor1");
      const svgGradientStop2 = map.querySelector("#grStopColor2");

      const MIN_SIZE_DESKTOP = 200;
      const MIN_SIZE_TAB = 250;
      const MIN_SIZE_MOBILE = 160;

      let activeCountries = [];
      let activeLocationBtn = null;

      const moveTo = (selectors, regionType = 'UK') => {
        // Создаем уникальный идентификатор для этой анимации
        const animationId = selectors.join(',') + regionType;

        // Если уже идет анимация к той же цели - игнорируем
        if (currentAnimationTarget === animationId) {
          return;
        }

        // Прерываем все активные анимации
        activeAnimations.forEach(anim => anim.kill());
        activeAnimations = [];

        // Устанавливаем новую цель анимации
        currentAnimationTarget = animationId;

        activeCountries.forEach((country) => {
          country.style.fill = "url(#magenta-gr-2)";
          svgGrayStop1.attributes["stop-color"].value = "#0891FA";
          svgGrayStop2.attributes["stop-color"].value = "#0891FA";
          svgGradientStop1.attributes["stop-color"].value = "#0891FA";
          svgGradientStop2.attributes["stop-color"].value = "#0891FA";
        });

        const countries = selectors.map((selector) => {
          const el = map.querySelector(selector);
          if (!el) console.warn(`Element ${selector} not found in SVG`);
          return el;
        }).filter(el => el);

        if (!countries.length) {
          console.warn("No active countries found");
          return;
        }

        const svgBox = countries[0].getBBox();

        countries.forEach((country) => {
          const { x, y, width, height } = country.getBBox();

          if (x < svgBox.x) {
            svgBox.width += svgBox.x - x;
            svgBox.x = x;
          }
          if (y < svgBox.y) {
            svgBox.height += svgBox.y - y;
            svgBox.y = y;
          }
          if (x + width > svgBox.x + svgBox.width)
            svgBox.width = x + width - svgBox.x;
          if (y + height > svgBox.y + svgBox.height)
            svgBox.height = y + height - svgBox.y;

          if (activeCountries.length) country.style.fill = "url(#magenta-gr)";
        });

        let minSize = isMob.matches
          ? MIN_SIZE_MOBILE
          : isTab.matches
            ? MIN_SIZE_TAB
            : MIN_SIZE_DESKTOP;

        if (svgBox.width < minSize) {
          svgBox.x -= (minSize - svgBox.width) / 2;
          svgBox.width = minSize;
        } else {
          svgBox.x -= (svgBox.width * 0.3) / 2;
          svgBox.width += svgBox.width * 0.3;
        }
        if (svgBox.height < minSize) {
          svgBox.y -= (minSize - svgBox.height) / 2;
          svgBox.height = minSize;
        } else {
          svgBox.y -= (svgBox.height * 0.3) / 2;
          svgBox.height += svgBox.height * 0.3;
        }

        let xPos = REGION_OFFSET[regionType] || REGION_OFFSET.UK;

        if (activeCountries.length) {
          const anim1 = gsap.to(svgGrayStop1, {
            duration: 1,
            attr: {
              "stop-color": "#0891FA",
            },
            ease: "power3.inOut",
          });
          const anim2 = gsap.to(svgGrayStop2, {
            duration: 1,
            attr: {
              "stop-color": "#0891FA",
            },
            ease: "power3.inOut",
          });
          const anim3 = gsap.to(svgGradientStop1, {
            duration: 1,
            attr: {
              "stop-color": "#0891FA",
            },
            ease: "power3.inOut",
          });
          const anim4 = gsap.to(svgGradientStop2, {
            duration: 1,
            attr: {
              "stop-color": "#0891FA",
            },
            ease: "power3.inOut",
          });
          const anim5 = gsap.to(map, {
            duration: 1,
            attr: {
              viewBox: [svgBox.x + xPos, svgBox.y, svgBox.width, svgBox.height].join(" "),
            },
            ease: "power3.inOut",
            onComplete() {
              activeCountries.forEach((country) => {
                country.style.fill = "";
              });
              activeCountries = countries;
              activeCountries.forEach((country) => {
                country.style.fill = "url(#magenta-gr)";
              });

              currentAnimationTarget = null; // Сбрасываем цель анимации
            },
          });
          activeAnimations.push(anim1, anim2, anim3, anim4, anim5);
        } else {
          const anim1 = gsap.to(map, {
            duration: 1,
            attr: {
              viewBox: [svgBox.x + xPos, svgBox.y, svgBox.width, svgBox.height].join(" "),
            },
            ease: "power3.inOut",
            onComplete() {
              activeCountries.forEach((country) => {
                country.style.fill = "";
              });

              svgGrayStop1.attributes["stop-color"].value = "#0891FA";
              svgGrayStop2.attributes["stop-color"].value = "#0891FA";

              activeCountries = countries;
              activeCountries.forEach((country) => {
                country.style.fill = "url(#magenta-gr)";
              });

              const anim2 = gsap.to(svgGradientStop1, {
                duration: 1,
                attr: {
                  "stop-color": "#0891FA",
                },
                ease: "power3.inOut",
              });
              const anim3 = gsap.to(svgGradientStop2, {
                duration: 1,
                attr: {
                  "stop-color": "#0891FA",
                },
                ease: "power3.inOut",
                onComplete() {
                  currentAnimationTarget = null; // Сбрасываем цель анимации
                },
              });
              activeAnimations.push(anim2, anim3);
            },
          });
          activeAnimations.push(anim1);
        }
      };

      const showAll = () => {
        // Прерываем все активные анимации
        activeAnimations.forEach(anim => anim.kill());
        activeAnimations = [];

        // Сбрасываем цель анимации
        currentAnimationTarget = null;

        activeLocationBtn?.classList.remove("active");
        activeLocationBtn = null;
        setPercBtnDisebling();

        const anim1 = gsap.to(map, {
          duration: 1,
          attr: {
            viewBox: baseViewBox,
          },
          ease: "power3.inOut",
          onComplete() {
            svgGrayStop1.attributes["stop-color"].value = "#0891FA";
            svgGrayStop2.attributes["stop-color"].value = "#0891FA";
            svgGradientStop1.attributes["stop-color"].value = "#0891FA";
            svgGradientStop2.attributes["stop-color"].value = "#0891FA";

            activeCountries.forEach((country) => {
              country.style.fill = "url(#magenta-gr)";
            });
            const activeCountriesIds = activeCountries.map(
              (item) => "#" + item.id
            );
            setDefaultCountries(defaultCountries, false, activeCountriesIds);

            const anim2 = gsap.to(svgGradientStop1, {
              duration: 1,
              attr: {
                "stop-color": "#0891FA",
              },
              ease: "power3.inOut",
            });
            const anim3 = gsap.to(svgGradientStop2, {
              duration: 1,
              attr: {
                "stop-color": "#0891FA",
              },
              ease: "power3.inOut",
              onComplete() {
                activeCountries.forEach((country) => {
                  country.style.fill = "url(#magenta-gr-2)";
                });

                activeCountries = [];
              },
            });
            activeAnimations.push(anim2, anim3);
          },
        });
        activeAnimations.push(anim1);
      };

      const setPercBtnDisebling = () => {
        if (!openPercBtn) return;
        openPercBtn.style.opacity = activeLocationBtn ? "1" : "0";
        openPercBtn.style.pointerEvents = activeLocationBtn ? "auto" : "none";
      };

      setPercBtnDisebling();

      // Централизованная функция для активации региона
      const activateRegion = (btn, chartName, selectors, regionType, allowToggle = true) => {
        // Проверяем, не активна ли уже эта кнопка (только если разрешен toggle)
        if (allowToggle && btn === activeLocationBtn) {
          showAll();
          activeChart?.classList.remove("active");
          activeChart = null;
          return;
        }

        // Обновляем состояние кнопки
        activeLocationBtn?.classList.remove("active");
        btn.classList.add("active");
        if (officesTitle) officesTitle.textContent = btn.dataset.infoTitle;
        if (officesText) officesText.textContent = btn.dataset.infoText;
        activeLocationBtn = btn;
        setPercBtnDisebling();

        // Обновляем график
        if (activeChart) activeChart.classList.remove("active");
        activeChart = getChart(chartName);
        if (activeChart) activeChart.classList.add("active");

        // Перемещаем карту
        moveTo(selectors, regionType);
      };

      const setDefaultCountries = (list, addListener = true, ignored = []) => {
        list.forEach((tabObj) => {
          tabObj.list.forEach((country) => {
            const countryPath = map.querySelector(country);

            // Проверяем, что страна найдена на карте
            if (!countryPath) {
              console.warn(`Country ${country} not found on map`);
              return;
            }

            if (!ignored.includes(country)) {
              countryPath.style.fill = "url(#magenta-gr-2)";
              countryPath.style.cursor = "pointer";
            }

            if (addListener) {
              countryPath.addEventListener("click", (e) => {
                e.stopPropagation();
                // Определяем, какой регион активировать на основе страны
                if (tabObj.btn === moveUkBtn) {
                  activateRegion(moveUkBtn, "uk-ireland", ["#GB", "#IR"], "UK", true);
                } else if (tabObj.btn === moveUsaBtn) {
                  let selectors = ["#CA", "#US"];
                  if (window.innerWidth <= 640) {
                    selectors = ["#CA", "#US"];
                  }
                  activateRegion(moveUsaBtn, "us-canada", selectors, "USA", true);
                } else if (tabObj.btn === moveEuBtn) {
                  activateRegion(moveEuBtn, "eu", euCountries, "EU", true);
                }
              });
            }
          });
        });
      };

      setDefaultCountries(defaultCountries);

      map.addEventListener("click", ({ target }) => {
        if (activeCountries.length && !activeCountries.includes(target)) {
          showAll();
          activeChart?.classList.remove("active");
          activeChart = null;
        }
      });

      moveUkBtn.addEventListener("click", () => {
        activateRegion(moveUkBtn, "uk-ireland", ["#GB", "#IR"], "UK");
      });

      moveUsaBtn.addEventListener("click", () => {
        let selectors = ["#CA", "#US"];
        if (window.innerWidth <= 640) {
          selectors = ["#CA", "#US"];
        }
        activateRegion(moveUsaBtn, "us-canada", selectors, "USA");
      });

      moveEuBtn.addEventListener("click", () => {
        activateRegion(moveEuBtn, "eu", euCountries, "EU");
      });

      if (openPercBtn) {
        openPercBtn.addEventListener("click", () => {
          activeChart?.classList.toggle("is-open");
          setMobileInfoHeader(Boolean(activeChart?.classList.contains("is-open")));

          if (isInfoMob.matches) {
            scrollLock.getScrollState()
              ? scrollLock.disablePageScroll(
                document.querySelector(".navbar-nav .menu")
              )
              : scrollLock.enablePageScroll();
          }
        });
      }

      closePercBtns.forEach((btn) => {
        btn.addEventListener("click", () => {
          activeChart?.classList.remove("is-open");
          scrollLock.enablePageScroll();
          setMobileInfoHeader(false);
        });
      });

      chartWrapCloseBtns.forEach((btn) => {
        btn.addEventListener("click", () => {
          showAll();
          activeChart?.classList.remove("active");
          activeChart = null;
        });
      });

      const observerOptions = {
        root: null,
        rootMargin: '0px',
        threshold: 0.3
      };

      const observerCallback = (entries, obs) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && isFirstZoom) {
            isFirstZoom = false;
            obs.disconnect();
            setTimeout(() => {
              moveUkBtn.click();
            }, 300);
          }
        });
      };

      const observer = new IntersectionObserver(observerCallback, observerOptions);
      observer.observe(mapSection);

    } catch (e) {
      console.info(e);
      setMapRetryCount++;
      if (setMapRetryCount < SET_MAP_MAX_RETRIES) {
        setTimeout(setMap, 500);
      } else {
        console.error('[Map] Failed to initialize after', SET_MAP_MAX_RETRIES, 'attempts');
      }
    }
  };

  const mapWrap = mapSection.querySelector(".map__wrap");
  const mapUrl = mapWrap.dataset.src;

  if (mapUrl) {
    fetch(mapUrl)
      .then((response) => response.text())
      .then((svg) => {
        mapWrap.innerHTML = svg;
        setMap();
      })
      .catch((e) => console.error(e));
  }
}
